<template>
	<div id='balanceSheet' >
		<div class="public-content">
			<div class="balanceSheet_top clearfix">
				<el-form :inline="true" class='fl balanceSheetForm'>
					<el-form-item label="资产负债表">
						<accounting-period ref="accountingPeriod" @defaultTime='defaultTime' :isDaterange='false'></accounting-period>
					</el-form-item>
				</el-form>
				<el-form :inline="true" class='fl balanceSheetForm'>
					<el-form-item>
					    <el-button size='mini' class='balanceSheet_elButtom minButton' @click='buttonSeach'>搜索</el-button>
					    <el-checkbox v-model='form.reclassify' @change="handlerClickR">重分类</el-checkbox>
					    <el-popover
						placement="bottom"
						width="920"
						trigger="hover"
						:offset="150"
						>
						<public-table :table='gridData'></public-table>
						<i slot="reference" class="el-icon-warning" style="color:#E6A23C;height:32px;"></i>
						</el-popover>
						<el-popover
						placement="bottom-start"
						width="800"
						trigger="click"
						>
					    <img src="static/img/reportFormula.png" alt="">
						<el-button style="background:#269D7B;color:#fff;margin-left:20px;" size="small" slot="reference">报表公式设置</el-button>
					    </el-popover>
					</el-form-item>
				</el-form>
				<div class="fr">
					<print-operation
						:formData="printForm"
						:showContinuit="false"
					></print-operation>
					<el-button  size='mini'  @click="openContinuity">批量打印</el-button>
					<el-button  size='mini'  @click="handleDownload">导出</el-button>
				</div>
			</div>
			<public-table :table='tableData'>
				<template v-if="item.show == 'template'" v-for="(item,index) in tableData.config" slot-scope="props" :slot="item.value"  >
					<div :key="index" v-if="props.scope.row[item.name]">
						<template v-if="props.scope.row[item.name].style !== '3' && props.scope.row[item.name].style !== '4'">
							<a
								href="javascript:;"
								v-text="props.scope.row[item.name].name"
								@click="handlerClick(props.scope.row[item.name])">
							</a>
						</template>
						<template v-else>
							<span >{{ props.scope.row[item.name].name }}</span>
						</template>
					</div>
					<div :key="index" v-else>
					<span v-if="item.label!='行次'">
						{{disposeMoney(validate(props.scope.row,item.value))}}
					</span>
					<span v-else>
						{{validate(props.scope.row,item.value)}}
					</span>
					</div>
				</template>
			</public-table>
		</div>
    <continuity-dialog :showVisible.sync = "continuityShow" @submitPrint = "openContinuityPage"></continuity-dialog>
		<balance-sheet-dialog
		  :ruleOfFetch="'余额'"
      :showPlace = "2"
			:dialogVisible.sync="isShowReport"
			@onRefresh='onRefresh'
			:data="reportDialogData"
			:showRegulation="true">
		</balance-sheet-dialog>
	</div>
</template>
<script>
	import publicTable from '@/components/publicTable'
	import accountingPeriod from '@/components/dialog/accountingPeriod'
	import {currencys} from '@/assets/utils/currencyFormat'
	import balanceSheetDialog from '@/components/dialog/balanceSheetDialog'
	import printOperation from '@/components/print'
  import {mapState,mapMutations} from 'vuex';
  import continuityDialog from "@/components/print/continuityDialog"
	export default {
		components: {
			publicTable,
      continuityDialog,
			accountingPeriod,
			balanceSheetDialog,
			printOperation,
		},
		data() {
			return {
        continuityShow: false, // 连续打印弹框是否显示
				gridData:{
          currencys,
					border: true,
					data:Object.freeze([
					{
						logic:'应收账款',
						noReclassification:"应收账款（余额）",
						reclassification:
						`应收账款 （所有下级科目的借方余额）
						+ 预收账款（所有下级科目的借方余额）`
					},{
						logic:'应付账款',
						noReclassification:"应付账款（余额）",
						reclassification:`应付账款（所有下级科目的贷方余额）
						+预付账款（所有下级科目的贷方余额）`
					},{
						logic:'预收账款',
						noReclassification:"预收账款（余额）",
						reclassification:`预收账款（所有下级科目的贷方余额）
						+应收账款（所有下级科目的贷方余额）`
					},{
						logic:'预付账款',
						noReclassification:"预付账款（余额）",
						reclassification:`预付账款（所有下级科目的借方余额）
						+应付账款（所有下级科目的借方余额）`
					},{
						logic:'其他应收款',
						noReclassification:"其他应收款（余额）",
						reclassification:`其他应收款（所有下级科目的借方余额）
						+其他应付款（所有下级科目的借方余额）`
					},{
						logic:'其他应付款',
						noReclassification:"其他应付款（余额）",
						reclassification:`其他应付款（所有下级科目的贷方余额）
						+其他应收款（所有下级科目的贷方余额）`
					},
				   ]),
					config:[{
						label: '取数逻辑',
						value: 'logic',
						show: 'normal',
						width:10,
					},{
						label: '不重分类',
						value: 'noReclassification',
						show: 'normal',
						width:10,
					},{
						label: '重分类',
						value: 'reclassification',
						show: 'normal',
						width:30
					}]
				},
				isFirstActive: false,
				printForm: {        // 打印参数
					data: {
						reclassify: false,
						yearPeriods: ''
					},
					url: '/createPDF/printAssets',
					continuityUrl: '/createPDF/printAssets'
				},
				form: {
					reclassify: false,
					yearPeriods: ''
				},
				reportDialogData: {
					reportId: '',
					yearPeriods: '',
					style: '1'
				},
				value1: '',
				isShowReport: false,          // 弹框显示
				tableData: {
					border: true,				// 是否带有纵向边框
					stripe: true,				// 是否带有斑马纹
					loading: false,				// 是否显示加载动画
					hasSelect: false,			// 是否显示多选
					hasOperation: false,		// 是否有操作功能
					hasContextmenu: false,		// 是否有右键功能
					hasShowSummary: false,		// 是否显示合计行
					hasShowPagination: false,	// 是否显示分页
					config: [{
						label: '资产',
						value: 're1.name',
						name: 're1',
						width: 210,
						show: 'template'
					},{
						label: '行次',
						value: 're1.rowNumber',
						width: 80,
						show: 'template'
					},{
						label: '年初数',
						value: 're1.beginYearNumber',
						show: 'template'
					},{
						label: '期末数',
						value: 're1.finalNumber',
						show: 'template'
					},{
						label: '负债和所有者（或股东）权益',
						value: 're2.name',
						name: 're2',
						width: 210,
						show: 'template'
					},{
						label: '行次',
						value: 're2.rowNumber',
						width: 80,
						show: 'template'
					},{
						label: '年初数',
						value: 're2.beginYearNumber',
						show: 'template'
					},{
						label: '期末数',
						value: 're2.finalNumber',
						show: 'template'
					}],
					operation: {
						label: '操作',
						value: 'operation',
						data: []
					},
					data: [],
					page: {
						pageNo: 1,
						pageSize: 20,
						count: 10
					},
					center: {
						textAlign: 'center',
						padding: '6px 0',
					}
				},
			}
		},
		created() {
      this.$nextTick(() => {
        this.setFaultDate()
        this.buttonSeach();
      })

		},
		 computed: {
        ...mapState([
          'accountInfo'
        ]),
	      getClickCache() {
	        return this.$store.state.loadstatus.isClickCache;
	      }
	    },
	    activated() {
	      if(this.getClickCache&&this.isFirstActive) {
          this.setFaultDate()
	        this.buttonSeach();
	      }
	      this.isFirstActive = true;
	    },
		methods: {
      // 路由有日期需要赋默认参数
      setFaultDate() {
        const { date } = this.$route.query
        if(date) {
          this.form.yearPeriods = date
          this.printForm.data.yearPeriods = date
          this.$refs.accountingPeriod.setYearPeriodsStart(new Date(date.slice(0,4)+'-'+date.slice(4,6)))
        }
      },
      disposeMoney(val) {
        return currencys(val)
      },
			validate(obj, name) {
				let defaultValue = obj[name];
				 if(!obj.hasOwnProperty(name)){
				    let attributeIndex = name.indexOf('.')
				    let attributeKey = name.slice(0,attributeIndex)
				    let attributeVal = name.slice(attributeIndex+1)
						defaultValue = obj[attributeKey][attributeVal]
					}
					return defaultValue;
			},
			// 表格格式化
			formatter(row, column, cellValue, index) {
				if(!cellValue) {
					return "";
				}else {
					return currencys(cellValue);
				}
			},
      // 打开连续打印弹框
      openContinuity() {
        this.continuityShow = true
      },
      // 打开连续打印网页
      openContinuityPage(data) {
        const params = {
          cid: sessionStorage.cid,
          token: sessionStorage.token,
          start:data.startYearPeriods,
          end: data.endYearPeriods,
          reclassify: this.form.reclassify,
          typeArr: data.types
        }

        const router = this.$router.resolve({
          path: '/createPDF/batchPrintingOfReports',
          query: params
        })

        window.open(this.$rootUrl + router.href, '_blank');
      },
			// 导出
			handleDownload (){
				const params = {
					cid: sessionStorage.cid,
					token: sessionStorage.token,
					yearPeriods: this.form.yearPeriods,
					reclassify: this.form.reclassify
				}

				const router = this.$router.resolve({
					path: '/reportform/exportpropertyChart',
					query: params
				})

				window.open(this.$rootUrl + router.href, '_blank');
			},
			// 重分类
			handlerClickR() {
				this.printForm.data.reclassify = this.form.reclassify ;
				this.buttonSeach()
			},
			// 刷新页面
			onRefresh(data) {
				if(data) {
					this.buttonSeach();
				}
			},
			// 接收会计期间数据
			defaultTime(data) {
        console.log(data);
				this.form = Object.assign(this.form,{
					yearPeriods: this.$util.formatDate.format(data.yearPeriodsStart , 'yyyyMM'),
				})
				this.printForm.data.yearPeriods = this.form.yearPeriods;
			},
			// 表格点击事件
			handlerClick(row) {
				this.reportDialogData = Object.assign(this.reportDialogData, {
					reportId: row.id,
					yearPeriods: this.form.yearPeriods,
					style: row.style
				})
				this.isShowReport = true;
			},
			// 获取资产负载表
			buttonSeach() {
				try{
					this.tableData.config.forEach(item=>{
						if(item.value == 're2.name' && this.accountInfo.isPrivateNop){
						item.label = '负债和净资产';
						}
					});

					this.tableData.loading = true;
					this.$http.post('reportform/propertyChartData' , this.form).then(res=>{
						this.tableData.loading = false;
						if(res && res.data.code == 1) {
							if(!res.data.data.length) return;
							this.tableData.data = res.data.data;
							this.tableData.data.forEach((item,index)=>{
								for (const i in item.re1) {
									if (typeof item.re1[i] === 'number') {
										item.re1[i] = item.re1[i] == 0 ? '' : item.re1[i];
									}
								}
								for (const j in item.re2) {
									if (typeof item.re2[j] === 'number') {
										item.re2[j] = item.re2[j] == 0 ? '' : item.re2[j];
									}
								}
							})

							let finalItem = this.tableData.data.slice(-1)[0];
							if(finalItem.re1.beginYearNumber != finalItem.re2.beginYearNumber) {
								this.handleTip(1);
							}else if(finalItem.re1.finalNumber != finalItem.re2.finalNumber) {
								this.handleTip(2);
							}
						}
					})
          console.log(this.tableData);
				}catch(e) {
					this.tableData.loading = false;
				}

			},
			handleTip(type) {  // 数据不平提示
				let accountingSystemCode = JSON.parse(sessionStorage.getItem('accountInfo')).accountingSystemCode,text = "";
				if(accountingSystemCode == "70") {  // 民间非盈利
					text = `资产负债表中资产总计${ type == 1?' 年初数 ':' 期末数 ' }与负债和净资产总计${ type == 1?' 年初数 ':' 期末数 ' }不等！`
				}else {
					text = `资产负债表中资产总计${ type == 1?' 年初数 ':' 期末数 ' }与负债和所有者权益（或股东权益）总计${ type == 1?' 年初数 ':' 期末数 ' }不等！`
				}
				this.$confirm(text, '提示', {
					confirmButtonText: '知道了',
					showCancelButton: false,
					closeOnClickModal: false,
					closeOnPressEscape: false,
					type: 'warning'
				}).then(() => {

				})
			},
		},
		mounted() {

		}
	}
</script>
<style lang='less'>
	#balanceSheet {
		.balanceSheet_top {
			.balanceSheetForm {
				.balanceSheet_elButtom {
					margin: 0 20px;
				}
			}
		}
    .el-table__body{
      .el-table__row{
        height: 36px;
      }
    }
	}
</style>



// WEBPACK FOOTER //
// src/pages/reportForm/balanceSheet.vue